import { z } from "zod";
import { getArticleParamSchema } from "./get-article.schema";

export const getVendorArticleParamSchema = z
	.object({
		vendorArticleId: z.uuid(),
	})
	.and(getArticleParamSchema);

export type GetVendorArticleParamSchema = z.infer<typeof getVendorArticleParamSchema>;
